import { useState, useEffect } from "react";
import commonLookup from "../../../services/commonLookupService";
import {
  Card,
  Form,
  Input,
  Row,
  Col,
  Select,

} from "antd";

import { recordError } from "../../../utils/logService";
import { ContactField } from "@seims/shared";

import {  util } from '@seims/shared';

export default function ProjectLead({ onSetNextStatus, formRef, data }) {

  const [titles, setTitles] = useState([]);
  const [contactValue, setContactValue] = useState("");

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "ProjectLeadForm";
  const formItemLayout = {
    layout: "vertical",
  };

  useEffect(() => {
    getTitles();
  }, []);

  useEffect(() => {
    prePopulate();
  }, [data]);

  const prePopulate = () => {
    if (!util.isEmpty(data)) {
      form.setFieldsValue({
        title: data.title.value,
        firstName: data.firstName,
        lastname: data.lastname,
        email: data.email,
      })
      setContactValue(data.contactNumber);
    }
  };

  const getTitles = async () => {
    try {
      const response = await commonLookup.getTitles();
      if (response) {
        const { data } = response;
        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const handleContactChange = (value) => {
    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ contactNumber: undefined });
      return;
    }
    form.setFieldsValue({ contactNumber: value });
  };
  const onSubmit = async (values) => {
    // try {
    const {
      title,
      firstname,
      surname,
      contactNumber,
      email,
    } = values;
    // const projectLeadData = {
    //   id: projectLeadData?.id > 0 ? projectLeadData.id : "-1",
    //   title: title,
    //   name: firstname,
    //   surname: surname,
    //   contactNumber: contactNumber,
    //   email: email,
    // };
    const request = "Done";
    // const request = await api.addProjectLead(projectLeadData);
    var msg;

    // } catch (error) {

    //   recordError(error);
    // }
  };

  return (
    <>
      <Card
        bordered={true}
        headStyle={{ border: 0, textAlign: "center" }}
      >
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          onFinish={onSubmit}
          scrollToFirstError
          ref={formRef}
          disabled={true}
        >
          <Row>
            <Col xs={24} md={10}>
              <Form.Item
                name="title"
                label="Title"
              >
                <Input name="title" />
              </Form.Item>
            </Col>
            <Col md={2}></Col>
            <Col xs={24} md={10}>
              <Form.Item
                name="firstName"
                label="Name"
              >
                <Input name="firstName" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={10}>
              <Form.Item
                name="lastname"
                label="Surname"
              >
                <Input name="lastname" />
              </Form.Item>
            </Col>
            <Col span={2}></Col>

          </Row>
          <Row>
            <Col xs={24} md={10}>
              <Form.Item
                name="contactNumber"
                label="Contact no"
              >
                <ContactField
                  contactValue={contactValue}
                  onContactChange={handleContactChange}
                />
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col xs={12} md={10}>
              <Form.Item
                name="email"
                label="Email"
              >
                <Input name="email" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  )
}
